import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ChatBubble from "./ChatBubble";
import AssessmentRequestModal from "./AssessmentRequestModal";

const PUBLIC_PATH_PREFIXES = ["/", "/programs", "/coaches"];

export default function Layout() {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const [assessOpen, setAssessOpen] = useState(false);
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);

    const isPublic =
        pathname === "/" ||
        PUBLIC_PATH_PREFIXES.some((p) => p !== "/" && pathname.startsWith(p));

    const handleAssessment = () => {
        if (pathname === "/") {
            // We're already on home — open the assessment modal in-page
            setAssessOpen(true);
        } else {
            // Send them to home with a hash so the home page can open the modal
            navigate("/?book=1", { replace: false });
        }
    };

    return (
        <div className="min-h-screen bg-brand-obsidian text-white" data-testid="site-layout">
            <Navbar />
            <main>
                <Outlet />
            </main>
            <Footer />
            {isPublic && <ChatBubble onAssessmentClick={handleAssessment} />}
            <AssessmentRequestModal open={assessOpen} onClose={() => setAssessOpen(false)} />
        </div>
    );
}
